/**
 * A simple utility to append the provided fragments with the given query
 * @param {String} query
 * @param {Objects} fragments
 */
const withFragments = (query, fragments) => `${query} ${Object.values(fragments).join('\n')}`;

/**
 * Parse page ID from the wagtail preview token
 * @param {string} token wagtail preview token to parse
 */
const extractPageID = (token) => {
  const [fragment] = token.split(':');
  const [, id] = fragment.split('=');
  return parseInt(id, 10);
};

export default withFragments;
export { extractPageID };
